import React from 'react';
import { localDateKey, todayKey } from '../../../utils/datetime';

const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Compact weekday pills (matches the duty roster's daily-view chips). The week
// to render is computed by the parent and passed in as `weekDates`.
const DateSelector = ({ weekDates = [], date, onChange }) => (
  <div className="flex items-center gap-2 px-1 flex-wrap">
    {weekDates.map((d) => {
      const key = localDateKey(d);
      const isSelected = key === date;
      const isToday = key === todayKey();
      return (
        <button
          key={key}
          onClick={() => onChange(key)}
          className={`relative flex items-center gap-2 px-3.5 py-2 rounded-xl transition shadow-sm ${
            isSelected
              ? 'bg-[#2563EB] text-white'
              : isToday
                ? 'bg-white dark:bg-[#31373f] text-[#475569] dark:text-gray-400 ring-2 ring-inset ring-[#2563EB] hover:bg-blue-50'
                : 'bg-white dark:bg-[#31373f] text-[#475569] dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-[#31373f]'
          }`}
        >
          <span className={`text-[11px] font-bold uppercase tracking-wider ${isSelected ? 'text-blue-100' : isToday ? 'text-[#2563EB]' : 'text-[#94A3B8] dark:text-gray-500'}`}>
            {DOW[d.getDay()]}
          </span>
          <span className="text-[14px] font-bold leading-none">{d.getDate()}</span>
          {isSelected && (
            <span className="text-[10px] font-semibold uppercase tracking-wide text-blue-100 ml-0.5">{MON[d.getMonth()]}</span>
          )}
        </button>
      );
    })}
  </div>
);

export default DateSelector;
